import { Component, ElementRef, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@app/auth/auth.service';
import { ScheduleComponent } from '@app/schedule/schedule.component';
import { Clinic } from '@models/clinic';
import { User } from '@models/user';
import { ClinicsService } from '@services/clinics.service';
import { EventsService } from '@services/events.service';
import { UsersService } from '@services/users.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-mobile-nav',
  templateUrl: './mobile-nav.component.html',
  styleUrls: ['./mobile-nav.component.less'],
})
export class MobileNavComponent implements OnInit, OnDestroy {
  clinic: Clinic;
  companyClinics: Clinic[] = [];
  user: User;
  currentDate: Date;
  displayCalendar = false;
  isScheduleActive = false;

  private touchstartX = 0;
  private readonly touchSensitivity = 120;
  private unsub: Subject<void> = new Subject<void>();

  @ViewChild(MatCalendar, { read: ElementRef }) calendar: ElementRef;
  @ViewChild('changeClinicModal') changeClinicModal: TemplateRef<any>;
  dialogRef: MatDialogRef<any>;

  @HostListener('touchstart', ['$event'])
  touchStart(event: TouchEvent) {
    this.touchstartX = event.changedTouches[0].screenX;
  }

  @HostListener('touchend', ['$event'])
  touchEnd(event: TouchEvent) {
    const touchendX = event.changedTouches[0].screenX;
    if (touchendX < this.touchstartX - this.touchSensitivity) {
      // swiped left
      this.goForwardOneDay();
    }
    if (touchendX > this.touchstartX + this.touchSensitivity) {
      // swiped right
      this.goBackOneDay();
    }
  }

  @HostListener('click', ['$event'])
  click(event: PointerEvent) {
    const target = event.target as HTMLElement;
    const calClicked = this.calendar?.nativeElement.contains(target);
    if (!calClicked) {
      this.displayCalendar = false;
    }
  }

  constructor(
    private clinicsService: ClinicsService,
    private usersService: UsersService,
    private authService: AuthService,
    private eventsService: EventsService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.clinicsService.getClinicsForCompany().subscribe((clinics) => {
      this.companyClinics = clinics ?? [];
    });

    this.clinicsService.clinicIdSelected$.subscribe((clinicId) => {
      this.clinic = this.clinicsService.clinic;
    });

    this.usersService.loggedInUserUpdated$.subscribe((user) => {
      this.user = user;
    });

    this.eventsService.currentDate.subscribe((date) => {
      this.currentDate = date;
    });
  }

  onOutletActivate(event: any) {
    this.isScheduleActive = event instanceof ScheduleComponent;
  }

  openCalendar(event: Event) {
    event.stopPropagation();
    this.displayCalendar = !this.displayCalendar;
  }

  setSelectedDate(date: moment.Moment) {
    this.eventsService.selectedDate.next(date.toDate());
    this.displayCalendar = false;
  }

  goBackOneDay() {
    this.eventsService.selectedDate.next(new Date(this.currentDate.setDate(this.currentDate.getDate() - 1)));
  }

  goForwardOneDay() {
    this.eventsService.selectedDate.next(new Date(this.currentDate.setDate(this.currentDate.getDate() + 1)));
  }

  goToToday() {
    this.eventsService.selectedDate.next(new Date());
  }

  changeClinic() {
    this.dialogRef = this.dialog.open(this.changeClinicModal);
  }

  logout() {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this.unsub.next();
    this.unsub.complete();
  }
}
